<!-- Toast notifications -->
<p-toast key="switch-webhook-success" position="top-right"></p-toast>
<p-toast key="switch-webhook-error" position="top-right"></p-toast>

<!-- Modern Header Section -->
<div class="m-4">
  <div class="webhook-client-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="webhook-client-title">
          <i class="pi pi-link mr-3"></i>
          My Webhooks
        </h1>
        <p class="webhook-client-subtitle">
          View and submit data to your assigned webhooks
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Main Content Area -->
<div class="webhook-client-content">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="loading-content">
      <p-progressSpinner
        strokeWidth="3"
        animationDuration=".5s"
        styleClass="loading-spinner"
      ></p-progressSpinner>
      <p class="loading-text">Loading webhooks...</p>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && (!webhooks || webhooks.length === 0)" class="empty-state-container">
    <div class="empty-state-card">
      <div class="empty-content">
        <i class="pi pi-info-circle empty-icon"></i>
        <h3>No Webhooks Found</h3>
        <p>No webhooks have been assigned to your account yet</p>
      </div>
    </div>
  </div>

  <!-- Webhooks Grid -->
  <div *ngIf="!loading && webhooks && webhooks.length > 0" class="webhooks-grid">
    <div
      *ngFor="let webhook of webhooks; let i = index"
      class="webhook-card"
    >
      <div class="webhook-card-header">
        <div class="webhook-icon">
          <i class="pi pi-link"></i>
        </div>
        <h3 class="webhook-name">{{ webhook.webhook_name }}</h3>
      </div>

      <div class="webhook-card-content">
        <div class="webhook-field">
          <label class="field-label">
            <i class="pi pi-file-edit mr-2"></i>
            Description
          </label>
          <p class="field-value" [innerHTML]="webhook.description"></p>
        </div>
      </div>

      <div class="webhook-card-actions">
        <button
          pButton
          pRipple
          label="Submit"
          icon="pi pi-upload"
          class="modern-button primary"
          (click)="openDialog(webhook)"
        ></button>
      </div>
    </div>
  </div>
</div>
